import { Routes } from '@angular/router';
import {
  DocumentClient,
  EquipmentClient,
  FinalMeasurementClient,
  GeneralAgreementClient,
  InfoDocumentClient,
  OfferClient,
  ProjectClient,
  RoleClient,
  UserClient,
  UserRegistrationClient,
} from '@api/api';
import { MsalGuard } from '@azure/msal-angular';
import { AuthGuardFn, Role, RoleGuardFn } from '@core';
import { LoginGuard } from '@core/guards/login.guard';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { AppFooterLayoutComponent, AppLayoutComponent } from '@theme';
import { ProjectsEffects, projectsFeature } from './projects/store/projects-store';

export const routes: Routes = [
  {
    path: '',
    component: AppFooterLayoutComponent,
    children: [
      {
        path: 'data-privacy',
        loadComponent: () =>
          import('./data-privacy/data-privacy.component').then(c => c.DataPrivacyComponent),
      },
      {
        path: 'login',
        canActivate: [LoginGuard],
        loadComponent: () => import('./login/login.component').then(c => c.LoginComponent),
      },
      {
        path: 'register',
        loadChildren: () => import('./register/routes'),
        providers: [UserRegistrationClient, RoleClient],
      },
      {
        path: 'sessions',
        loadChildren: () => import('./sessions/routes'),
        data: { title: 'Sessions', titleI18n: 'sessions' },
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    component: AppLayoutComponent,
    canMatch: [AuthGuardFn, MsalGuard],
    children: [
      {
        path: 'projects',
        loadChildren: () => import('./projects/routes'),
        providers: [
          ProjectClient,
          OfferClient,
          FinalMeasurementClient,
          DocumentClient,
          EquipmentClient,
          GeneralAgreementClient,
          provideState(projectsFeature),
          provideEffects(ProjectsEffects),
        ],
      },
      {
        path: 'address',
        canMatch: [RoleGuardFn],
        data: { roles: [Role.Admin] },
        loadComponent: () => import('./addresses/addresses').then(c => c.AddressesComponent),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./user-settings/user-settings.component').then(c => c.UserSettingsComponent),
      },
      {
        path: 'informations',
        loadComponent: () =>
          import('./informations/informations.component').then(c => c.InformationsComponent),
        providers: [UserClient, RoleClient, InfoDocumentClient],
      },
      {
        path: 'support',
        loadComponent: () => import('./support/support.component').then(c => c.SupportComponent),
      },
      {
        path: 'users',
        canMatch: [RoleGuardFn],
        data: { roles: [Role.Admin] },
        loadChildren: () => import('./user-management/routes'),
        providers: [UserClient, RoleClient],
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
